import { Component } from '@angular/core';


@Component({
  standalone: true,
  imports: [],
  selector: 'lib-search-expert-no-filtered-record',
  template: `
    <div class="text-center py-8">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="mx-auto h-12 w-12 text-gray-400"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
        />
      </svg>
      <h3 class="mt-2 text-sm font-medium text-gray-700">No experts found</h3>
      <p class="mt-1 text-sm text-gray-500">
        Try adjusting your search criteria.
      </p>
    </div>
  `,
})
export class SearchExpertNoFilteredRecordComponent {}
